import { render, staticRenderFns } from "./ItemFilter.vue?vue&type=template&id=859f1f0a"
import script from "./ItemFilter.vue?vue&type=script&lang=js"
export * from "./ItemFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports